<template>
  <!-- Meetups.vue --><div>
  <div class="container">
    <v-layout class="mt-5">
      <v-flex xs12 class="text-xs-center">
        <v-progress-circular
          indeterminate
          class="primary--text"
          :width="7"
          :size="70"
          v-if="loading"
        ></v-progress-circular>
      </v-flex>
    </v-layout>

    <div class="row" v-if="!loading">
      <div class="col-md-4" v-for="blog in blogs" :key="blog.id">
        <div class="card mx-auto" style="width: 18rem; cursor:pointer; height:100%">
          <img
            :src="blog.imageUrl"
            class="d-block w-100"
            width="100%"
            height="200px"
            alt="..."
            @click="onLoadBlog(blog.id)"
            style="object-fit:cover;"
          />
          <div class="card-body">
            <h5 class="card-title" @click="onLoadBlog(blog.id)">
              {{ blog.title }}
            </h5>
            <hr
              class="line text-center"
              style="margin-bottom:20px; margin-top:-10px"
            />
            <p class="card-text">
              {{ blog.shortDescription ? blog.shortDescription: shortenDescription(blog.description) }}

              <v-icon left right @click="onLoadBlog(blog.id)"
                >arrow_forward</v-icon
              >
            </p>

            <p class="card-text">
              <small class="text-muted">{{ fixDate(blog.date) }}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
     </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  computed: {
    blogs() {
      return this.$store.getters.loadedBlogs;
    },
    user() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  filters: {
    fixDescription: function(value) {
      const findDot = value.indexOf(".");
      var result = "";
      if (findDot === -1) {
        result = value;
      } else {
        result = value.substr(0, findDot + 1);
      }
      return result;
    },
  },
  methods: {
    shortenDescription: function(value) {
      var maxLength = 60;
      var trimmedString = value.substr(0, maxLength);
      trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))+ "... Read more"
      return trimmedString;
    },
    onLoadBlog(id) {
      this.$router.push("/blogs/" + id);
    },
    fixDate(date) {
      const fixedDate = new Date(date);
      return fixedDate.toLocaleDateString('sr') + " " + fixedDate.toLocaleTimeString('sr', {hour: '2-digit', minute:'2-digit'})
    }
  },
  components:{
    Footer
  }
};
</script>

<style scoped>
hr.line {
  border: 1px solid #ffd700;
  width: 100px;
  margin: 0px auto;
}
</style>
